import './style.scss';
import { DateTime } from 'luxon';
import { TranslationService } from '../../../services/translation.service';
import type { ILine } from '../../../models/line.model';
import { LineHelper } from '../../../helpers/line.helper';
import TransportModeIcon from '../TransportModeIcon';

const translationLine = TranslationService.get('common.line');
const translationFrom = TranslationService.get('common.from');

function LineListShowcase({
  lines,
  showNonTrainDirectionName,
  showTrainDirectionName = true,
  directionAsStrong,
  showAppliesFromDateOnFutureLines,
  className,
}: {
  lines: ILine[];
  showNonTrainDirectionName?: boolean;
  showTrainDirectionName?: boolean;
  directionAsStrong?: boolean;
  showAppliesFromDateOnFutureLines?: boolean;
  className?: string;
}) {
  // === VARIABLES ===
  const now = DateTime.now();
  const transportModes = [...new Set(lines.map((line) => line.transportMode))];

  return (
    <div className={`line-list-showcase w-100${className ? ` ${className}` : ''}`}>
      {transportModes.map((transportMode, i) => (
        <div key={transportMode} className={`align-items-center w-100 d-flex position-relative ${i < transportModes.length - 1 ? 'mb-2' : ''}`}>
          <TransportModeIcon className="line-list-showcase__transport-mode flex-shrink-0 me-1" transportMode={transportMode} />
          <div
            className={`d-flex mb-n1 w-100 ${transportMode === 'train' && showTrainDirectionName ? 'flex-column' : ''} ${
              transportMode !== 'train' && showNonTrainDirectionName ? 'flex-column' : 'flex-wrap'
            }`}
          >
            {lines
              .filter((line) => line.transportMode === transportMode)
              .map((line) => (
                <div key={line.gid}>
                  {transportMode !== 'train' ? (
                    <div className="mb-1 d-flex align-items-center me-1">
                      <div
                        className={`line-list-showcase__line py-1 px-1 flex-shrink-0 text-center rounded border ${showNonTrainDirectionName ? 'me-2' : ''}`}
                        style={{
                          backgroundColor: LineHelper.getBackgroundColor(line),
                          color: LineHelper.getForegroundColor(line),
                          borderColor: LineHelper.getBorderColor(line),
                        }}
                      >
                        <span className="visually-hidden">{translationLine} </span>
                        {line.name ? <span className="fw-bold">{line.name}</span> : <span className="fw-bold">{line.shortName}</span>}
                      </div>
                      {showNonTrainDirectionName && (
                        <div className="line-list-showcase__direction-name flex-shrink-1">
                          <span className={directionAsStrong ? 'fw-bold' : ''}>{line.directionName}</span>
                          {showAppliesFromDateOnFutureLines && line.appliesFrom && line.appliesFrom > now && <span className="ps-1">({LineHelper.getAppliesFromText(line, translationFrom)})</span>}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="line-list-showcase__line w-100 mb-1 d-flex align-items-center flex-no-wrap me-1">
                      <div
                        className={`py-1 px-1 text-center rounded d-inline-block flex-shrink-0 border ${showTrainDirectionName ? 'me-2' : ''}`}
                        style={{
                          backgroundColor: LineHelper.getBackgroundColor(line),
                          color: LineHelper.getForegroundColor(line),
                          borderColor: LineHelper.getBorderColor(line),
                        }}
                      >
                        <span className="visually-hidden">{translationLine} </span>
                        <span className="fw-bold">{line.name}</span>
                      </div>
                      {showTrainDirectionName && (
                        <div className="line-list-showcase__direction-name flex-shrink-1">
                          <span className={directionAsStrong ? 'fw-bold' : ''}>{line.directionName}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default LineListShowcase;
